import { getDoctorById, getDoctorByUserId } from "../../services/doctorService";

const getCurrentOrganizationId = () => {
  const storedOrgId = localStorage.getItem("organizationId");
  if (storedOrgId) {
    const parsed = Number(storedOrgId);
    if (!Number.isNaN(parsed) && parsed > 0) return parsed;
  }

  const storedUser = localStorage.getItem("user");
  if (storedUser) {
    try {
      const parsedUser = JSON.parse(storedUser);
      const userOrgId = parsedUser?.organizationId;
      if (userOrgId != null && userOrgId !== "" && !Number.isNaN(userOrgId) && Number(userOrgId) > 0) {
        return Number(userOrgId);
      }
    } catch (_) {
      // ignore
    }
  }
  return null;
};

const isValidName = (value) =>
  value && value !== "N/A" && value !== "null" && value !== null && typeof value === "string" && value.trim();

export const resolveIpdDoctorName = async (item, nameCache = new Map()) => {
  if (isValidName(item?.assignedByName)) return item.assignedByName.trim();
  if (isValidName(item?.resolvedDoctorName)) return item.resolvedDoctorName.trim();
  if (isValidName(item?.doctorName)) return item.doctorName.trim();

  const assignedById = item?.assignedBy;
  if (!assignedById || assignedById === "null" || assignedById === "") return "N/A";
  if (nameCache.has(assignedById)) return nameCache.get(assignedById);

  const currentOrganizationId = getCurrentOrganizationId();
  const numericId = typeof assignedById === "string" ? parseInt(assignedById, 10) : assignedById;
  if (Number.isNaN(numericId)) return "N/A";

  const cacheAndReturn = (name) => {
    const resolved = name || "N/A";
    nameCache.set(assignedById, resolved);
    return resolved;
  };

  const validateDoctorOrg = (doctor) => {
    if (!currentOrganizationId || !doctor) return true;
    const doctorOrgId = doctor?.organizationId || doctor?.organization_id;
    if (doctorOrgId == null || doctorOrgId === "") return false;
    return Number(doctorOrgId) === currentOrganizationId;
  };

  try {
    const doctorByUser = await getDoctorByUserId(numericId);
    if (doctorByUser?.name && validateDoctorOrg(doctorByUser)) {
      return cacheAndReturn(doctorByUser.name);
    }
  } catch (error) {
    if (error?.response?.status !== 404) {
      console.warn(`[resolveIpdDoctorName] getDoctorByUserId failed for ID ${assignedById}:`, error.message);
    }
  }

  try {
    const doctorById = await getDoctorById(numericId);
    if (doctorById?.name && validateDoctorOrg(doctorById)) {
      return cacheAndReturn(doctorById.name);
    }
  } catch (error) {
    if (error?.response?.status !== 404) {
      console.warn(`[resolveIpdDoctorName] getDoctorById failed for ID ${assignedById}:`, error.message);
    }
  }

  return cacheAndReturn("N/A");
};
